// Mirrors cloud-server's PERMISSION_LEVEL, which decides whether a role clears a CLI command.
export const CLI_ROLE_RANK: Record<string, number> = {
  'super admin': 5,
  admin: 4,
  'release manager': 4,
  support: 3,
  accountant: 2,
  'professional services': 1,
  'pre-sales': 1,
  guest: 0,
};

export const CLI_DEFAULT_ROLE = 'support';
